export const zh = {
  title: 'PRODES（亚马逊合法）',
  subtitle: '年度，6.25公顷，合法亚马逊，INPE',
  content: [
    {
      label: '功能',
      value: '巴西合法亚马逊森林砍伐监测系统，巴西政府用来制定公共政策',
    },
    {
      label: '分辨率',
      value: '6.25公顷',
    },
    {
      label: '地理覆盖范围',
      value: '巴西合法亚马逊',
    },
    {
      label: '来源',
      value: '国家教育局',
    },
    {
      label: '更新频率',
      value: '每年',
    },
    {
      label: '内容日期',
      value: '2008-2021',
    },
    {
      label: '注意事项',
      value:
        'PRODES 仅识别 6.25 公顷或更大的森林空地，因此不会检测到森林退化或因火灾或选择性伐木而造成的较小空地。覆盖范围内频繁的云层覆盖可能会改变报告的森林砍伐年份。报告的年份是分析师确定森林砍伐的第一年，但如果前几年景观被云层覆盖，则这不一定对应于森林砍伐的年份。',
    },
    {
      label: '许可证',
      value: '知识共享 BY SA 3.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      'PRODES 项目监测巴西亚马逊和塞拉多生物群落的砍伐森林，并计算自 1988 年以来该地区的年度毁林率。巴西政府利用这些数据制定公共政策，包括确定亚马逊生物群落的信贷准入、制定减少毁林目标以及筹集资金以减少毁林。 PRODES 过去使用的是 Landsat 5 图像，但现在还合并了来自 Landsat 7 和 8、CBERS-2、CBERS-2B、Resourcesat-1 和 UK2-DMC 的图像。 PRODES 由国家空间研究所 (INPE) 与环境部 (MMA) 和巴西环境与可再生自然资源研究所 (IBAMA) 合作运营。自 2002 年以来，所有 PRODES 数据均可在线公开获取。覆盖巴西亚马逊和塞拉多的 220 个 Landsat 足迹中的每一个的输入图像都是根据其云层覆盖情况和捕获日期来选择的。 PRODES 系统使用从 8 月 1 日开始的季节性年份来计算每年的森林砍伐量，因此选择尽可能接近该日期的图像（通常是 7 月、8 月和 9 月）。从 2003 年到 2005 年，分析人员使用 SPRING 程序通过图像变换来确定植被、土壤和阴影的组成部分。这些组成部分被细分为森林、非森林、目标年份的森林砍伐、以前的森林砍伐、云和水等类别，然后由专家进行手动校正。从 2005 年开始，实施了一种利用开源 TerraAmazon 平台的新方法。该平台使 PRODES 分析更加统一，并且可以合并来自各种卫星的图像。和以前一样，图像被选择为尽可能无云。然后使用前一年的分析对图像进行屏蔽，以排除非森林、之前的森林砍伐和水。然后，分析人员在前一年完整的森林中描绘出被砍伐的多边形。该数据集显示了 2008 年至 2020 年巴西合法亚马逊地区的年度森林砍伐情况。',
  },
  citation: {
    label: '引用',
    value: '国家空间研究所（INPE）。 “提倡砍伐森林。”于[日期]通过全球森林观察访问。 www.globalforestwatch.org',
  },
};
